"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.445 7.686a.7.7 0 0 1-.618.773 1.54 1.54 0 0 0-.923.445c-.26.26-.408.59-.445.93a.7.7 0 1 1-1.392-.15 2.944 2.944 0 0 1 2.605-2.615.7.7 0 0 1 .773.617m1.857 1.812a.7.7 0 0 1 .637.758 2.944 2.944 0 0 1-2.71 2.685.7.7 0 0 1-.107-1.396 1.543 1.543 0 0 0 1.423-1.41.7.7 0 0 1 .757-.637",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 5.7c-2.333 0-4.42 1.284-5.357 3.237A2.46 2.46 0 0 0 4.4 10c0 .365.082.727.243 1.063q.204.424.474.801a.7.7 0 1 1-1.139.814 7 7 0 0 1-.597-1.01A3.86 3.86 0 0 1 3 10c0-.577.13-1.146.381-1.669C4.566 5.861 7.165 4.3 10 4.3c.601 0 1.191.07 1.76.204a.7.7 0 1 1-.322 1.362A6.3 6.3 0 0 0 10 5.7m5.045 1.459a.7.7 0 0 1 .977.162q.34.476.597 1.01a3.856 3.856 0 0 1 0 3.337C15.434 14.14 12.835 15.7 10 15.7c-.6 0-1.19-.07-1.757-.203a.7.7 0 0 1 .32-1.363A6.27 6.27 0 0 0 10 14.3c2.333 0 4.42-1.284 5.357-3.237a2.457 2.457 0 0 0 0-2.126 5.4 5.4 0 0 0-.474-.802.7.7 0 0 1 .162-.976",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.495 3.505a.7.7 0 0 1 0 .99l-12 12a.7.7 0 0 1-.99-.99l12-12a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EyeHideIcon20.js.map